import { render } from "./PagamentoSuccesso.vue?vue&type=template&id=928a7156&scoped=true"
import script from "./PagamentoSuccesso.vue?vue&type=script&lang=js"
export * from "./PagamentoSuccesso.vue?vue&type=script&lang=js"

import "./PagamentoSuccesso.vue?vue&type=style&index=0&id=928a7156&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-928a7156"]])

export default __exports__